/**
 * オリジナルデザイン（OD）の検索ページ（page-od-search.php・search.php）
 * MEMO: 旧 js/od-search.js の ESM 版（種類ごとの全チェック・全解除と、OD アプリへの遷移）
 *       旧版はログインを確認しておらず、ログイン中でも必ず同意モーダルが出ていた（詳細ページと同じく、ログイン中は出さない）
 */
import { onReady, queryAll } from '@/utils/dom'
import { initOdDesignForm } from '@/utils/od-design'

onReady(() => {
  //種類ごとの「すべて選択」・「すべて解除」
    queryAll('[data-button-type]').forEach((button) => {
        button.addEventListener('click', () => {
            const checked = button.dataset.buttonType==='true'
            button.closest('.od-search_types')?.querySelectorAll<HTMLInputElement>('input[type="checkbox"]').forEach((check) => { check.checked = checked })
        })
    })
    initOdDesignForm({ checkLogin: true })
})
